<template>
  <div class="notification-body">
    <article class="mt-1" v-html="localizedBody" />
  </div>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    localizedBody: {
      get() {
        return this.$i18n.locale === 'en' ? this.item.notificationBodyEn : this.item.notificationBodyIdn;
      },
      set(value) {
        if (this.$i18n.locale === 'en') {
          this.$set(this.item, 'notificationBodyEn', value);
        } else {
          this.$set(this.item, 'notificationBodyIdn', value);
        }
      }
    }
  }
};
</script>

<style>
.notification-body {
  overflow-x: auto !important;
}
</style>
